var module = angular.module('octopusApp.configuration');

module.controller('DiagnosticsScheduledTaskController', function ($scope, $timeout, $state, octopusLog, busy, octopusRepository, $location, pollLoop, $q) {
    var isLoading = $scope.isLoading = busy.create();

    $scope.scheduledTaskName = $state.current.data.scheduledTaskName;
    // $scope.diagnosticTab = $route.current.$$route.diagnosticTab;

    $scope.rootNode = new Octopus.Model.LogTreeNode();
    $scope.rootNode.isExpanded = true;
    $scope.isVerbose = false;
    $scope.isTail = true;

    var rebuildTree = function rebuildTreeCallback(activityLog) {
        if (!activityLog) {
            return;
        }
        $scope.rootNode.refresh(activityLog);
    };

    $scope.toggleGap = function () {
        $scope.isTail = false;
        reload();
    };

    var reload = function () {
        var taskDetailOptions = {
            verbose: $scope.isVerbose
        };
        if ($scope.isTail) {
            taskDetailOptions.tail = 20;
        }

        var all = [
          isLoading.promise(octopusRepository.Scheduler.getDetails($scope.scheduledTaskName, taskDetailOptions))
        ];

        return $q.all(all).then(function (result) {
            var details = result[0];
            rebuildTree(details.ActivityLog);
        });
    };

    $scope.showVerbose = function() {
        $scope.isVerbose = true;
        reload();
    };
    reload();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/diagnostics/controllers/diagnotics_scheduled_task_controller.js
// module id = 387
// module chunks = 1